/*
 * @Description:
 * @Author: Luke Z
 * @Date: 2021-05-10 00:22:39
 * @LastEditors: Luke Z
 * @LastEditTime: 2021-05-12 14:01:44
 * @FilePath: /unifyxp-v2-store-portal/src/pages/ProductEditor/Components/Tags/Tags.tsx
 */
import Input from '@/src/components/Antd/Input/Input';
import Tag from '@/src/components/InputBreakTag/Tag';
import ItemWrapper from '@/src/components/Layouts/Item/Item';
import Row from '@/src/components/Layouts/Row/Row';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import Link from '@/src/components/Link/Link';
import _ from 'lodash';
import React from 'react';
import { useDispatch } from 'react-redux';
import { useI18n } from 'src/hooks/useRouterChange';
import { createTag } from 'src/request/tag/tag';
import { i18nGet } from 'src/tools/tools';
import css from './css.less';

interface IProps {
  setInputTags;
  inputTags;
  tags;
  setTags;
  hideSectionTitle?;
  disabled?;
}
const Tags = (props: IProps) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const { tags, inputTags, setInputTags, setTags, hideSectionTitle, disabled } =
    props;
  const dispatch = useDispatch();
  const onClose = (e, index) => {
    const tagsCopy = _.cloneDeep(tags);
    tagsCopy.splice(index, 1);
    dispatch(setTags({ tags: tagsCopy }));
  };
  const pressEnter = (value) => {
    //用户点击回车事件
    // const { value } = e.target;
    const tagsCopy = _.cloneDeep(tags);
    const tagsName = tagsCopy.map((o) => o.name);
    const valueFormat = inputTags.replace(/[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g, '');
    if (tagsName.includes(valueFormat)) {
      setInputTags('');
    } else {
      if (valueFormat)
        createTag({ name: valueFormat }).then((res) => {
          tagsCopy.push(res);
          setInputTags('');
          dispatch(setTags({ tags: tagsCopy }));
        });
    }
  };
  const _tags = (
    <Row
      elements={[
        {
          child: (
            <div
              style={{
                width: '50%',
              }}>
              <ItemWrapper
                title={getI18n('general.tags')}
                rightSubTitle={getI18n(
                  'allProducts.addproductset.pressentertoaddtag',
                )}>
                <Input
                  maxLength={50}
                  size='large'
                  placeholder={getI18n('allProducts.addproductset.addnewtag')}
                  value={inputTags}
                  onChange={(value) => setInputTags(value)}
                  onPressEnter={(e) => pressEnter(e)}
                  disabled={disabled}
                />
                <div>
                  {tags.map((item, index) => (
                    <Tag
                      index={index}
                      key={(item || {}).uuid}
                      tagType='InputBreak'
                      disabled={disabled}
                      tagClose={onClose}>
                      {(item || {}).name}
                    </Tag>
                  ))}
                </div>
              </ItemWrapper>
            </div>
          ),
        },
      ]}
    />
  );
  return !hideSectionTitle ? (
    <SectionWrapper
      title={getI18n('general.tags')}
      rightPart={
        // to='/settings/tagManager'
        <Link to='tags' className={css.tagsRightPart}>
          {getI18n('allProducts.addproductset.tags_component_tag')}
        </Link>
      }>
      {_tags}
    </SectionWrapper>
  ) : (
    _tags
  );
};
export default Tags;
